import React from 'react';
import EquipmentForm from '../../equipmentSurveys/components/EquipmentForm';
import { BasicInfo, CurrentPractices } from './components/';
import {
  ReplacementAssessment,
  NewEquipment,
  PurchasingDecision
} from '../components';

function IrrigationEngine({
  applicationData,
  setApplicationData,
  equipmentType
}) {
  return (
    <EquipmentForm
      applicationData={applicationData}
      setApplicationData={setApplicationData}
      equipmentType={equipmentType}
    >
      <BasicInfo />
      <ReplacementAssessment />
      <CurrentPractices />
      <NewEquipment />
      <PurchasingDecision />
    </EquipmentForm>
  );
}

export default IrrigationEngine;
